import {makeStyles} from "@material-ui/core"

export default makeStyles(theme => ({
    wrapper: {
        width: 400,
    },
    container: {
        width: 320,
        height: 200,
        padding: "15px 10px",
        backgroundColor: "#fff",
        outline: "none",
        display: "flex",
        flexDirection: "column",
    },
    actions: {
        justifyContent: "flex-end",
    },
    checkbox_container: {
        justifyContent: "center",
    },
    footer_button: {
        margin: "0 10px",
    },
    conclusion_container: {
        marginBottom: theme.spacing(2),
    },
    conclusion_title: {
        fontSize: 18,
        fontWeight: 600,
    },
}))
